import * as React from "react";
import GithubMark from "react-github-mark";

export const Footer = () => (
  <footer>
    <GithubMark href="https://github.com/sysart/is-beer-cold" />
  </footer>
)


// WEBPACK FOOTER //
// ./src/Footer.tsx